"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function ALegacyOfHealing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="98626" id="our-mission-of-care" className="relative w-full min-h-[80vh] flex items-center py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/physiolux_cinematic_therapy.png" alt="Cinematic view of modern neurosurgical treatment" className="w-full h-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-primary/5 mix-blend-multiply" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 flex justify-center md:justify-end">
        {}
        <div ref={ref} className={`max-w-2xl bg-white/60 backdrop-blur-xl p-8 md:p-12 lg:p-16 shadow-lg border border-primary/10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-sans font-bold text-4xl md:text-5xl text-primary mb-8 tracking-tighter">
            Our Mission of Care
          </h2>

          <div className="space-y-6 text-foreground/80 text-lg leading-relaxed">
            {}
            <p className="first-letter:text-7xl first-letter:font-serif first-letter:italic first-letter:text-primary first-letter:float-left first-letter:mr-4 first-letter:mt-1 first-letter:leading-none">
              Founded on the profound philosophy of "Patient as Family," NeuroFamily was established to redefine neurosurgical care. We believe that every individual deserves the same level of compassion, respect, and meticulous attention we would provide to our own kin, creating a bond of trust that transcends the clinical setting.
            </p>

            <p>
              Today, we embrace the forefront of neurosurgical innovation while maintaining our core values. We integrate state-of-the-art minimally invasive technology and multidisciplinary expertise into a serene, healing environment. This evolution allows us to offer unparalleled precision in brain and spine care, ensuring our commitment to your recovery is empowered by the best of modern medicine.
            </p>
          </div>

          <div className="mt-10">
            <Button asChild variant="outline" size="lg" className="group rounded-full border-secondary text-secondary hover:bg-secondary hover:text-white transition-all duration-300">
              <Link to="/HealingPhilosophyPage">
                Discover Our Philosophy
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}